import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useCustomModel } from "components/context/CustomProvider";
import CustomModelProvider from "../CustomModelProvider";
import CustomDialog from "../CustomDialog";
import CustomViewModal from "../CustomViewModal";
import ModelUpdateModal from "./ModelUpdateModal";
import { useMemo } from "react";
import useDidValueChange from "components/hooks/useDidValueChanged";

const ModelViewModal = (modelName) => {
  if (!modelName) {
    throw new Error("ModelViewModal requires a modelName");
  }

  return NiceModal.create(({ id, path }) => {
    const modal = useModal();
    const model = useCustomModel(modelName);
    const updateModal = useMemo(
      () => model.updateModal || ModelUpdateModal(modelName),
      [modelName],
    );

    const title = (data) => {
      if (model.getTitle) {
        return model.getTitle(data);
      }
      if (data._title) {
        return data._title;
      }
      return `${modelName} View Modal`;
    };

    useDidValueChange(modal.hide, "modal.hide");
    //useDidValueChange(modal, "modal");

    return (
      <CustomDialog variant="drawer" open={modal.visible} onClose={modal.hide}>
        <CustomModelProvider
          modelName={modelName}
          id={id}
          onDeleted={modal.hide}
        >
          {(data, reftech) => (
            <CustomViewModal
              title={title(data)}
              data={data}
              fields={model.fields}
              onClose={modal.hide}
              path={path}
              updateForm={updateModal}
              modelName={modelName}
            />
          )}
        </CustomModelProvider>
      </CustomDialog>
    );
  });
};

export default ModelViewModal;
